module.exports = __webpack_public_path__ + "static/media/riskScoreZero.d679b0b7.mp3";